import { publicApi } from '@/api/instance'

export const GetSiteKey = async () => {
  const res = await publicApi({
    method: 'get',
    url: '/recaptcha/siteKey',
  })
  return res.data
}
